import { IColumns } from '../../../../../components/Dashboard/TableSmall'

export interface IPortfolioData {
  basket: string
  stake: string
  yield: string
}

export interface IData {
  request: string
  columns: IColumns[]
}

export const data: IData = {
  request: '/staking/portfolio',
  columns: [
    {
      // id: 'asset',
      id: 'basket',
      label: 'BASKET',
    },
    {
      // id: 'total',
      id: 'stake',
      label: 'STAKE',
      // eslint-disable-next-line
      // format: (value: any) => value.toFixed(3),
    },
    {
      id: 'yeild',
      label: 'YEILD',
      // eslint-disable-next-line
      // format: (value: any) => value.toFixed(3),
    },
    {
      id: 'twoButtons',
      label: '',
    },
  ],
}

export const stateData = [{ id: 1, basket: 'Asset 1', stake: '$10,000,00', yeild: '$2000' }]
